module.exports = __webpack_public_path__ + "img/addSection.5d6e3d24.png";